import { IArtist, ArtistEntity } from "./types";

/**
 * Artist entity schema convert to model
 */
export function mapArtistFromEntity(entity: ArtistEntity): IArtist {
    return {
        id: entity.id,
        key: entity.key,
        title: entity.title,
        adminTitle: entity.adminTitle || entity.title,
        description: entity.description,
        content: entity.content,
        order: entity.order || 0,
        profileImageVertical: entity.profileImageVertical,
        profileImageHorizontal: entity.profileImageHorizontal,
        language: entity.language,
        relationId: entity.languageRelationId,
        createdBy: entity.createdBy,
        updatedBy: entity.modifiedBy,
        createdAt: entity.createdOn || entity.CreatedOn,
        updatedAt: entity.modifiedOn || entity.ModifiedOn
    }
}

/**
 * Artist model schema convert to entity
 */
export function mapArtistFromModel(model: IArtist): ArtistEntity {
    return {
        id: model.id,
        key: model.key,
        adminTitle: model.title,
        title: model.title,
        description: model.description,
        order: model.order || 0,
        content: model.content,
        profileImageVertical: model.profileImageVertical,
        profileImageHorizontal: model.profileImageHorizontal,
        language: model.language,
        languageRelationId: model.relationId || undefined
    }
}

